export default __webpack_public_path__ + "static/media/020_start.d4bfc23b.mp3";